export enum AdminPortalUserRole {
  OrganizationAdmin = "Organization Admin",
  OrganizationUser = "Organization User"
}

export interface OrganizationUserDetails {
  readonly id: string;
  readonly organizationRole: AdminPortalUserRole | string;
  readonly displayName: string;
  readonly emailAddress: string;
  readonly createdOn: string;
  readonly state: string;
}

export type OrganizationUserDetailsKeys = keyof OrganizationUserDetails;

export interface OrganizationUserDetailsResponse {
  readonly users: OrganizationUserDetails[];
}
